import React from "react";
import "./index.css";

const CustomCheckBox = ({ checked }) => {
  return (
    <label className="checkbox-container">
      {!checked ? "Insurance not available" : "Insurance available"}
      <input type="checkbox" checked={checked} />
      <span className="checkmark"></span>
    </label>
  );
};

export default CustomCheckBox;
